import { useMemo } from 'react';
import { Form } from 'antd';

/**
 * Hook для создания функции фильтрации аэропортов,
 * которая исключает выбранный аэропорт из противоположного поля
 * 
 * @param form - Объект формы Ant Design
 * @param oppositeFieldName - Имя противоположного поля формы (string или array для Form.List)
 * @returns Объект с функцией fetchOptions и key для пересоздания компонента
 */
export const useAirportFilter = (form: any, oppositeFieldName: string | any[]) => {
  // Отслеживаем изменения значения противоположного поля
  const oppositeValue = Form.useWatch(oppositeFieldName, form);
  
  // Извлекаем ID из значения для использования в key
  const oppositeId = useMemo(() => {
    if (oppositeValue !== undefined && oppositeValue !== null) {
      if (typeof oppositeValue === 'object' && 'value' in oppositeValue) {
        return typeof oppositeValue.value === 'number' ? oppositeValue.value : undefined;
      } else if (typeof oppositeValue === 'number') {
        return oppositeValue;
      }
    }
    return undefined;
  }, [oppositeValue]);
  
  const fetchOptions = useMemo(() => {
    return (search?: string) => {
      // Извлекаем ID из значения, если это объект (DebounceSelect может возвращать объект)
      let excludeAirportId: number | undefined;
      if (oppositeValue !== undefined && oppositeValue !== null) {
        if (typeof oppositeValue === 'object' && 'value' in oppositeValue) {
          excludeAirportId = typeof oppositeValue.value === 'number' ? oppositeValue.value : undefined;
        } else if (typeof oppositeValue === 'number') {
          excludeAirportId = oppositeValue;
        }
      }
      
      // Динамически импортируем fetchAirports для избежания циклических зависимостей
      return import('../helpers/selectDataFetchers/fetchAirports').then(
        ({ fetchAirports }) => fetchAirports(search, excludeAirportId)
      );
    };
  }, [oppositeValue]);
  
  // Возвращаем объект с функцией и key для пересоздания компонента
  return {
    fetchOptions,
    key: `airport-filter-${oppositeId ?? 'none'}`,
  };
};
